var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "r-form__field" }, [
    !_vm.hideLabel
      ? _c("label", { staticClass: "control-label" }, [
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _vm.isRequired ? _c("span", [_vm._v("*")]) : _vm._e(),
          _vm._v(" "),
          _vm.hasTooltip
            ? _c("i", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.right",
                    value: _vm.tooltipText,
                    expression: "tooltipText",
                    modifiers: { right: true }
                  }
                ],
                staticClass: "fa fa-question-circle m-l-5"
              })
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "r-form__input", class: _vm.inputClasses },
      [_vm._t("input")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }